import { render, staticRenderFns } from "./Contributor.vue?vue&type=template&id=015d72db&scoped=true"
import script from "./Contributor.vue?vue&type=script&lang=js"
export * from "./Contributor.vue?vue&type=script&lang=js"
import style0 from "./Contributor.vue?vue&type=style&index=0&id=015d72db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d72db",
  null
  
)

export default component.exports